import { useState, useEffect } from "react";

import { Box, Skeleton } from "@mui/material";

import { getImage } from "../../../services/profileService";

const AsyncImage = ({
  imageId,
  width = 40,
  height = 40,
  alt = "Profile",
  ...rest
}) => {
  const [src, setSrc] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadImage = async () => {
      try {
        if (!imageId) return;

        const imageSrc = await getImage(imageId);

        if (isMounted) {
          setSrc(imageSrc);
        }
      } catch (error) {
        console.error("Image load error:", error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadImage();

    return () => {
      isMounted = false;
    };
  }, [imageId]);

  if (isLoading) {
    return <Skeleton variant="circular" width={width} height={height} />;
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      width={width}
      height={height}
      {...rest}
    />
  );
};

export default AsyncImage;
